import { render, staticRenderFns } from "./AutoBalance.vue?vue&type=template&id=12bb568a&"
import script from "./AutoBalance.vue?vue&type=script&lang=js&"
export * from "./AutoBalance.vue?vue&type=script&lang=js&"
import style0 from "./AutoBalance.vue?vue&type=style&index=0&id=12bb568a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports